/**
 * Build-time feature flags. Read from REACT_APP_* env vars by craco at build.
 * Default to false — staging social.doer.ar ships with all flags off until
 * we explicitly turn them on per environment.
 */

const flag = (key: string, fallback = false): boolean =>
  ((process.env[key] ?? String(fallback)).toString().toLowerCase() === 'true');

export const FEATURE_FLAGS = {
  /**
   * When true: mis-publicaciones shows an "Externo" tag on tasks added via
   * "Añadir con link externo" and renders task.caption ("copy") under each
   * card. Mirrors the backend USE_COPY_FROM_SOCIAL flag — keep both in sync
   * per environment so the displayed copy matches what was actually posted.
   */
  USE_COPY_FROM_SOCIAL: flag('REACT_APP_USE_COPY_FROM_SOCIAL'),

  /**
   * When true: surface the FakeSocialMedia provider in the connect modal and
   * in the connections page. Mirrors the backend ENABLE_FAKE_SOCIAL flag,
   * which is the one that actually mounts the /fakesocialmedia/* routes —
   * leaving them out of sync just means a button that 404s.
   */
  ENABLE_FAKE_SOCIAL: flag('REACT_APP_ENABLE_FAKE_SOCIAL'),

  /**
   * When true: the share modal shows a "Branded content" checkbox (default
   * unchecked) that, when ticked, forwards `brand_content_toggle=true` to
   * TikTok's /v2/post/publish/video/init/ — which makes TikTok label the
   * resulting post as commercial. Required by TikTok's Content Sharing
   * Guidelines for any app that publishes content related to a brand:
   * the UI must SURFACE the option even if most users will leave it off.
   * For Doer specifically the catalog clips are editorial content (not paid
   * promotion), so the toggle defaults to false — but the field has to
   * exist for the TikTok reviewer to see during app review.
   */
  SHOW_BRAND_CONTENT_TOGGLE: flag('REACT_APP_SHOW_BRAND_CONTENT_TOGGLE'),
};
